import type { FunctionComponent } from 'react';

import { useFeatureGate } from '@trello/feature-gate-client';

import { ResizableSplitScreenManager } from './ResizableSplitScreenManager';
import { SplitScreenManager } from './SplitScreenManager';

export const SplitScreenEntryComponent: FunctionComponent = () => {
  const { value: isResizingEnabled } = useFeatureGate(
    'phx_personal_productivity_panel_resize',
  );

  const SplitScreenManagerComponent = isResizingEnabled ? (
    <ResizableSplitScreenManager />
  ) : (
    <SplitScreenManager />
  );
  return SplitScreenManagerComponent;
};
